import PageWithHeadline from '@/components/layout/PageWithHeadline';
import { useUser } from '@/app/providers';
import { useSidePanelHandler } from '@/hooks/useSidePanelHandler';
import { CompanySidePanelHandler } from '@/features/companies/components/CompanySidePanelHandler';
import type { CompanySidePanelContent } from '@/features/companies/types';
import { useCallback } from 'react';
import { CompanyAdminContentView } from './CompanyAdminContentView';


export function CompanyAdminPage() {
  const { user } = useUser();
  const companyUuid = user?.companyUuid;
  const sidePanel = useSidePanelHandler<CompanySidePanelContent>();

  // The page always stays on the user's own company, so a clicked daughter company
  // opens in a side panel instead of replacing the content.
  const handleCompanyClick = useCallback(
    (company: { id: string; name: string }) => {
      sidePanel.open({ type: 'view', company: { uuid: company.id, name: company.name } });
    },
    [sidePanel]
  );

  if (!companyUuid) {
    return null;
  }

  return (
    <PageWithHeadline headlineKey="companyAdmin.title">
      <CompanyAdminContentView companyUuid={companyUuid} onCompanyClick={handleCompanyClick} />

      <CompanySidePanelHandler
        content={sidePanel.content}
        panelKey={sidePanel.panelKey}
        isOpen={sidePanel.isOpen}
        onClose={sidePanel.close}
      />
    </PageWithHeadline>
  );
}
